"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Tag;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _tag = _interopRequireDefault(require("@ux/tag"));
const TagLabel = /*#__PURE__*/(0, _react2.styled)("p")({
  name: "TagLabel",
  class: "core-t1x9s37j"
});
const StyledTag = /*#__PURE__*/(0, _react2.styled)(_tag.default)({
  name: "StyledTag",
  class: "core-s1dmdw2a"
});
const allowedEmphasisValues = ['default', 'critical', 'success', 'warning', 'info', 'highlight', 'neutral', 'internal', 'passive', 'premium'];
const designRemapping = {
  freemium: 'neutral'
};
function ensureValidEmphasis(design) {
  if (!design) {
    return 'default';
  }
  if (allowedEmphasisValues.includes(design)) {
    return design;
  }
  if (designRemapping[design]) {
    return designRemapping[design]; // Return the remapped value
  }
  return 'default';
}

/**
 * Render Tag
 * @module Tag
 *
 * @param {Object} props React props
 * @param {string} props.dataCy Tag data-cy
 * @param {string} [props.text] Tag Label
 * @param {string} props.design Tag design
 * @param {string} props.size Passes sm, md, lg but uses sm,lg only in FOS
 * @returns {React.ReactElement} Tag component
 * @public
 */
function Tag({
  dataCy,
  text,
  size = 'lg',
  design = 'default',
  className,
  ...otherTagProps
}) {
  if (!text) return null;
  return /*#__PURE__*/_react.default.createElement(TagLabel, {
    className: className || 'tag-element',
    "data-cy": dataCy || 'tag'
  }, /*#__PURE__*/_react.default.createElement(StyledTag, (0, _extends2.default)({
    emphasis: ensureValidEmphasis(design),
    size: size
  }, otherTagProps), text));
}
Tag.propTypes = {
  dataCy: _propTypes.default.string,
  text: _propTypes.default.string.isRequired,
  size: _propTypes.default.oneOf(['sm', 'md', 'lg']),
  design: _propTypes.default.oneOf(allowedEmphasisValues),
  ..._tag.default.propTypes
};